/** AppName used to identify Calendar Board default project */
export const OutlookCalendarAppName = 'OutlookCalendar';
